/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState} from 'react'
import clsx from 'clsx'
import ReactTooltip from 'react-tooltip'
import '../../../_metronic/assets/sass/components/cards.scss'
import '../../../_metronic/assets/sass/components/kanban.scss'
// import '../../../_metronic/assets/sass/core/vendors/plugins/_jkanban.scss'
import {Link} from 'react-router-dom'
import {BoardDropdown} from './BoardDropdown'
import {BoardMembers} from './BoardMembers'
import {BoardVisibility} from './BoardVisibility'
import {BoardShareMembers} from './BoardShareMembers'
import {ActionsList} from './ActionsList'
import {FiltersDropdown} from './FiltersDropdown'
import {Breadcrumbs} from '../Breadcrumbs'

import {KTSVG} from '../../../_metronic/helpers/components/KTSVG'
// import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
const crumbs = [
  {name: 'Dashboard', url: '/dashboard'},
  {name: 'kanban', url: '/kanbanboard'},
]
const KanbanBoard: FC = () => {
  return (
    <>
      <section className='tabs-main mb-5 pb-5'>
        <div className='container px-0'>
          <div className='card card-custom'>
            <div className='card-body p-0'>
              <div className='tab-content'>
                <div className='tab-pane tab-pane2 pb-5 active rounded'>
                  <Breadcrumbs crumbs={crumbs} />
                  <div className='row mx-10 mt-5'>
                    <div className='kanban-board-header-main px-0'>
                      <div className='left d-flex align-items-center w-100'>
                        <div className='board-views-btn d-none'>
                          <div className='card-toolbar'>
                            <button
                              type='button'
                              className=''
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-start'
                              data-kt-menu-flip='top-start'
                            >
                              <svg
                                width='16'
                                height='16'
                                className='me-2'
                                role='presentation'
                                focusable='false'
                                viewBox='0 0 24 24'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  fill-rule='evenodd'
                                  clip-rule='evenodd'
                                  d='M2 7V15C2 16.1046 2.89543 17 4 17H6C7.10457 17 8 16.1046 8 15V7C8 5.89543 7.10457 5 6 5H4C2.89543 5 2 5.89543 2 7ZM4 7V15H6V7L4 7Z'
                                  fill='currentColor'
                                ></path>
                                <path
                                  fill-rule='evenodd'
                                  clip-rule='evenodd'
                                  d='M9 7V13C9 14.1046 9.89543 15 11 15H13C14.1046 15 15 14.1046 15 13V7C15 5.89543 14.1046 5 13 5H11C9.89543 5 9 5.89543 9 7ZM11 7V13H13V7L11 7Z'
                                  fill='currentColor'
                                ></path>
                                <path
                                  fill-rule='evenodd'
                                  clip-rule='evenodd'
                                  d='M16 17V7C16 5.89543 16.8954 5 18 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H18C16.8954 19 16 18.1046 16 17ZM18 17V7L20 7V17H18Z'
                                  fill='currentColor'
                                ></path>
                              </svg>{' '}
                              Board
                              <i className='fa fa-angle-down ps-2'></i>
                            </button>
                            <div
                              className='menu menu-sub menu-sub-dropdown w-300px w-md-350px'
                              data-kt-menu='true'
                              style={{maxHeight: '345px', overflow: 'auto'}}
                            >
                              <BoardDropdown />
                            </div>
                          </div>
                        </div>
                        {/* new code for kanban board */}

                        {/* search input */}
                        <form
                          data-kt-search-element='form'
                          className='todo-bar-search-from position-relative px-3 boder-1 rounded'
                          autoComplete='off'
                          style={{width: '290px'}}
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen021.svg'
                            className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-0'
                          />

                          <input
                            type='text'
                            className='form-control form-control-flush py-2 ps-10'
                            name='search'
                            placeholder='Search...'
                            data-kt-search-element='input'
                            // onChange={searchHandler}
                          />

                          <span
                            className='btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 d-none'
                            data-kt-search-element='clear'
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr061.svg'
                              className='svg-icon-2 svg-icon-lg-1 me-0'
                            />
                          </span>
                        </form>
                        {/* search input */}
                        <div className='mx-4 side-margins-responsive'>
                          <button
                            className='btn btn-blue position-relative  fw-bolder fs-7 d-flex align-items-center'
                            style={{height: '31px', minWidth: '72px'}}
                          >
                            Summary
                          </button>
                        </div>
                        <div className='side-margins-responsive'>
                          <a className='btn btn-sm btn-light-primary' href='#'>
                            <span className='svg-icon svg-icon-3'></span>Issues
                          </a>
                        </div>
                        {/* new code for kanban board */}

                        {/* previous code */}

                        <div className='board-views-btn d-none'>
                          <div className='card-toolbar'>
                            <button
                              type='button'
                              className=''
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-start'
                              data-kt-menu-flip='top-start'
                            >
                              <i className='fa fa-users pe-2'></i>
                              work space visibility
                            </button>
                            <div
                              className='menu menu-sub menu-sub-dropdown w-250px w-md-300px'
                              data-kt-menu='true'
                              style={{maxHeight: '345px', overflow: 'auto'}}
                            >
                              <BoardVisibility />
                            </div>
                          </div>
                        </div>

                        <div className='kanban-header-facepile  mx-4'>
                          <ul>
                            <li>
                              <Link to='/' data-tip data-for='userTip1'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='John Smith (John Smith1)'
                                />
                              </Link>
                              <ReactTooltip id='userTip1' place='top' effect='solid'>
                                John Smith (John Smith1)
                              </ReactTooltip>
                            </li>
                            <li>
                              <Link to='/' data-tip data-for='userTip2'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='John Smith (John Smith1)'
                                />
                              </Link>
                              <ReactTooltip id='userTip2' place='top' effect='solid'>
                                John Smith (John Smith2)
                              </ReactTooltip>
                            </li>
                            <li>
                              <Link to='/' data-tip data-for='userTip3'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='John Smith (John Smith1)'
                                />
                              </Link>
                              <ReactTooltip id='userTip3' place='top' effect='solid'>
                                John Smith (John Smith3)
                              </ReactTooltip>
                            </li>
                            <li>
                              <span className='d-flex justify-content-center align-items-center badge rounded-pill  rounded-pill-radius bg-primary'>
                                4+
                              </span>
                            </li>
                            <li>
                              <Link to='/' data-tip data-for='userTip4'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='John Smith (John Smith1)'
                                />
                              </Link>
                              <ReactTooltip id='userTip4' place='top' effect='solid'>
                                John Smith (John Smith4)
                              </ReactTooltip>
                            </li>
                            <li>
                              <Link to='/' data-tip data-for='userTip5'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='John Smith (John Smith1)'
                                />
                              </Link>
                              <ReactTooltip id='userTip5' place='top' effect='solid'>
                                John Smith (John Smith5)
                              </ReactTooltip>
                            </li>
                            <li>
                              <Link to='/'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='John Smith (John Smith1)'
                                />
                              </Link>
                            </li>
                            <li>
                              <Link to='/'>
                                <img
                                  className='member-avatar'
                                  src='/media/avatars/blank.png'
                                  alt='Sobia Yaseen (sobiayaseen2)'
                                  title='Sobia Yaseen (sobiayaseen2)'
                                />
                              </Link>
                            </li>
                          </ul>
                          <div className='board-views-btn'>
                            <div className='card-toolbar'>
                              <div
                                className='menu menu-sub menu-sub-dropdown w-250px w-md-300px'
                                data-kt-menu='true'
                                style={{maxHeight: '345px', overflow: 'auto'}}
                              >
                                <BoardMembers />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='right d-flex'>
                        <div className='board-views-btn d-none'>
                          <div className='card-toolbar'>
                            <button
                              type='button'
                              className=''
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-end'
                              data-kt-menu-flip='top-end'
                            >
                              <svg
                                width='16'
                                height='16'
                                className='me-2'
                                role='presentation'
                                focusable='false'
                                viewBox='0 0 24 24'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M17.5009 2.65511C18.4967 2.5456 19.5352 2.80718 20.364 3.63597L18.9498 5.05019C18.6192 4.71958 18.2151 4.58335 17.7106 4.63884C17.1593 4.69947 16.4959 4.96246 15.7486 5.38541C15.0122 5.80221 14.272 6.32856 13.5675 6.8454C13.4614 6.92326 13.3548 7.00186 13.2485 7.08031C12.6795 7.50008 12.1166 7.91532 11.6552 8.18878C11.1608 8.48182 10.6363 8.46971 10.3204 8.43815C9.98837 8.40498 9.19934 8.39748 7.94353 8.81849C7.16614 9.07911 6.21617 9.69953 5.40597 10.3177L5.34387 10.3653C5.59079 10.4171 5.85122 10.4646 6.11263 10.5076C6.62099 10.5913 7.11123 10.6543 7.47593 10.6964C7.65774 10.7174 7.80708 10.7331 7.9103 10.7434C7.96189 10.7486 8.00189 10.7525 8.02858 10.755L8.0584 10.7578L8.06686 10.7585L8.96578 11.8603L8.96537 11.8658L8.96296 11.8884C8.96079 11.909 8.95758 11.9404 8.95366 11.9813C8.9458 12.0632 8.93516 12.1826 8.92441 12.3287C8.9028 12.6224 8.88136 13.0163 8.88048 13.4263C8.87958 13.8425 8.90011 14.2437 8.95265 14.563C8.9897 14.7881 9.03099 14.8963 9.04531 14.9338C9.04927 14.9442 9.05033 14.9497 9.05033 14.9497C9.05033 14.9497 9.05582 14.9507 9.06621 14.9547C9.10371 14.969 9.2119 15.0103 9.43702 15.0474C9.75627 15.0999 10.1575 15.1204 10.5737 15.1195C10.9837 15.1186 11.3777 15.0972 11.6714 15.0756L12.1391 15.0341L13.2414 15.933L13.3036 16.5241C13.3457 16.8888 13.4087 17.379 13.4924 17.8874C13.5354 18.1488 13.583 18.4092 13.6347 18.6561L13.6823 18.594C14.3005 17.7838 14.9209 16.8339 15.1815 16.0565C15.6025 14.8007 15.595 14.0116 15.5619 13.6796C15.5303 13.3637 15.5182 12.8392 15.8112 12.3448C16.0847 11.8834 16.4999 11.3206 16.9197 10.7515C16.9981 10.6452 17.0767 10.5386 17.1546 10.4325C17.6715 9.72798 18.1978 8.98784 18.6146 8.25143C19.0376 7.50416 19.3005 6.84067 19.3612 6.28939C19.4167 5.78487 19.2804 5.38079 18.9498 5.05019L20.364 3.63597C21.1928 4.46477 21.4544 5.50334 21.3449 6.4991C21.2405 7.4481 20.8244 8.39124 20.3504 9.22877C19.8702 10.0772 19.2817 10.9 18.762 11.6084C18.674 11.7284 18.5889 11.8439 18.5069 11.9552C18.0946 12.5148 17.7615 12.9669 17.5439 13.3284C17.5413 13.3535 17.5403 13.3991 17.5477 13.4727C17.6103 14.0997 17.58 15.1726 17.0735 16.6835C16.7017 17.7925 15.9064 18.9623 15.2669 19.8003C14.9374 20.2322 14.6293 20.6014 14.4034 20.8629C14.2902 20.9939 14.1971 21.0986 14.1314 21.1714C14.0985 21.2078 14.0725 21.2363 14.0543 21.2561L14.0267 21.286L14.0239 21.289C13.8388 21.4871 13.5813 21.6021 13.3108 21.6073C13.0403 21.6124 12.7798 21.5076 12.5889 21.3167C12.3731 21.1009 12.2313 20.8327 12.1361 20.6177C12.0339 20.3868 11.9481 20.1296 11.8751 19.8725C11.729 19.3576 11.6128 18.7648 11.5231 18.2197C11.4566 17.8154 11.4027 17.425 11.3611 17.0937C11.1199 17.1058 10.8496 17.1146 10.5694 17.1152C10.1037 17.1162 9.57892 17.0947 9.10468 17.0166C8.69213 16.9487 8.05261 16.7804 7.63611 16.3639C7.21962 15.9474 7.05129 15.3079 6.9834 14.8953C6.90535 14.4211 6.88378 13.8964 6.88478 13.4306C6.88539 13.1504 6.89426 12.8801 6.90635 12.6389C6.57502 12.5974 6.18466 12.5434 5.78029 12.4769C5.23522 12.3872 4.64237 12.271 4.12751 12.1249C3.8704 12.0519 3.61317 11.9661 3.38231 11.8639C3.16733 11.7687 2.89915 11.6269 2.68332 11.4111C2.49244 11.2202 2.38758 10.9597 2.39276 10.6892C2.39794 10.4187 2.51272 10.1614 2.71081 9.97631L2.71401 9.97332L2.72063 9.96718L2.74387 9.94573C2.76373 9.92748 2.79221 9.90147 2.82863 9.86862C2.90143 9.80296 3.00612 9.70979 3.13714 9.59661C3.39866 9.37069 3.76781 9.06262 4.19969 8.73309C5.03769 8.09367 6.20752 7.29836 7.31652 6.92656C8.8274 6.42004 9.90036 6.3897 10.5273 6.45233C10.6009 6.45968 10.6465 6.45871 10.6716 6.45614C11.0331 6.23853 11.4852 5.90543 12.0448 5.49314C12.1561 5.41114 12.2716 5.32601 12.3916 5.23804C13.1 4.71833 13.9228 4.12982 14.7712 3.64963C15.6088 3.1756 16.5519 2.75948 17.5009 2.65511Z'
                                  fill='currentColor'
                                ></path>
                                <path
                                  d='M15.4143 8.58572C15.8048 8.97624 16.438 8.97624 16.8285 8.58572C17.219 8.1952 17.219 7.56203 16.8285 7.17151C16.438 6.78098 15.8048 6.78098 15.4143 7.17151C15.0238 7.56203 15.0238 8.1952 15.4143 8.58572Z'
                                  fill='currentColor'
                                ></path>
                              </svg>
                              Power Ups
                            </button>
                            <div
                              className='menu menu-sub menu-sub-dropdown w-250px w-md-300px'
                              data-kt-menu='true'
                              style={{maxHeight: '345px', overflow: 'auto'}}
                            >
                              <BoardDropdown />
                            </div>
                          </div>
                        </div>
                        <div className='board-views-btn d-none'>
                          <div className='card-toolbar'>
                            <button
                              type='button'
                              className=''
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-end'
                              data-kt-menu-flip='top-end'
                            >
                              <i className='fa fa-bolt pe-2' aria-hidden='true'></i>
                              Automation
                            </button>
                            <div
                              className='menu menu-sub menu-sub-dropdown w-250px w-md-300px'
                              data-kt-menu='true'
                              style={{maxHeight: '345px', overflow: 'auto'}}
                            >
                              <BoardDropdown />
                            </div>
                          </div>
                        </div>
                        <div className='board-views-btn d-none'>
                          <div className='card-toolbar'>
                            {/* begin::Menu */}
                            <button
                              type='button'
                              className=''
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-end'
                              data-kt-menu-flip='top-center'
                            >
                              <i className='fa fa-share-alt' aria-hidden='true'></i>
                            </button>
                            <div
                              className='menu menu-sub menu-sub-dropdown w-300px w-md-500px'
                              data-kt-menu='true'
                              style={{maxHeight: '400px', overflow: 'auto'}}
                            >
                              <BoardShareMembers />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row drag-drop-card-main card-margins'>
                    <div className='mt-0' id='kanban-main'>
                      <div className='kanban-container'>
                        <div className='kanban-board'>
                          <main className='kanban-drag'>
                            <header className='kanban-board-header primary mb-6'>
                              <div className='kanban-title-board'>
                                <div className='d-flex justify-content-between align-items-center margin-10'>
                                  <div className='d-flex'>
                                    <a>
                                      {' '}
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        style={{marginRight: '-10px'}}
                                        viewBox='0 0 128 512'
                                      >
                                        <path d='M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z' />
                                      </svg>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        viewBox='0 0 128 512'
                                      >
                                        <path d='M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z' />
                                      </svg>
                                    </a>
                                    <h2 className='px-2'>
                                      Todo <span className='fs-12px'>3</span>
                                    </h2>
                                  </div>

                                  <a>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      height='15px'
                                      width='15px'
                                      viewBox='0 0 512 512'
                                    >
                                      <path d='M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z' />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                              <div className='scroll-class'>
                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3>Create three new Landing Page Template</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-red btn-sm  text-white'>Design</span>
                                    <span className='bg-light-blue btn-sm  mx-3 text-white'>
                                      Design
                                    </span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{width: '25%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        style={{marginRight: '7px'}}
                                        viewBox='0 0 512 512'
                                      >
                                        <path d='M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z' />
                                      </svg>
                                      <span>20 SEP</span>
                                    </div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>Captain - 1</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip1'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip1' place='top' effect='solid'>
                                              John Smith (John Smith1)
                                            </ReactTooltip>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3> Work flow & Prototype</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className=' bg-red btn-sm  text-white'>Design</span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-danger'
                                        role='progressbar'
                                        style={{width: '75%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip1'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip1' place='top' effect='solid'>
                                              John Smith (John Smith1)
                                            </ReactTooltip>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3>Create three new Landing Page Template</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-red btn-sm  text-white'>Design</span>
                                    <span className='bg-light-blue btn-sm  mx-3 text-white'>
                                      Design
                                    </span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{width: '25%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <span className='d-flex justify-content-center align-items-center badge rounded-pill  rounded-pill-radius bg-primary'>
                                              OF
                                            </span>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className='kanban-title-board kanban-add-card mb-6'>
                                  <div>
                                    <a className='kanban-board-add-card-hover'>
                                      <span>
                                        <i className='fa fa-plus' aria-hidden='true'>
                                          <span className='add-card'>Add a Card</span>
                                        </i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </header>
                          </main>
                        </div>

                        {/* second Board */}
                        <div className='kanban-board'>
                          <main className='kanban-drag'>
                            <header className='kanban-board-header primary mb-6'>
                              <div className='kanban-title-board'>
                                <div className='d-flex justify-content-between align-items-center margin-10'>
                                  <div className='d-flex'>
                                    <a>
                                      {' '}
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        style={{marginRight: '-10px'}}
                                        viewBox='0 0 128 512'
                                      >
                                        <path d='M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z' />
                                      </svg>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        style={{marginRight: '7  px'}}
                                        viewBox='0 0 128 512'
                                      >
                                        <path d='M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z' />
                                      </svg>
                                    </a>
                                    <h2 className='px-2'>
                                      InProgress <span className='fs-12px'>4</span>
                                    </h2>
                                  </div>

                                  <a>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      height='15px'
                                      width='15px'
                                      viewBox='0 0 512 512'
                                    >
                                      <path d='M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z' />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                              <div className='scroll-class'>
                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3>New Components</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-light-blue btn-sm mr-3 text-white'>
                                      vteams
                                    </span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{width: '25%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip1'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip1' place='top' effect='solid'>
                                              John Smith (John Smith1)
                                            </ReactTooltip>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3> Work flow & Prototype</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-red btn-sm  text-white'>Design</span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-danger'
                                        role='progressbar'
                                        style={{width: '75%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip1'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip1' place='top' effect='solid'>
                                              John Smith (John Smith1)
                                            </ReactTooltip>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='kanban-item p-0' data-className='light-primary'>
                                  <img
                                    src='/media/misc/pattern-1.jpg'
                                    className='kanban-image-ui'
                                  />
                                  <div className='p-3'>
                                    <span className='font-weight-bold w-70'>
                                      <h3 className='my-2'>
                                        Create three new Landing Page Template
                                      </h3>
                                    </span>
                                    <div className='d-flex mt-4'>
                                      <span className='bg-light-blue btn-sm  me-3 text-white mb-2'>
                                        vteams
                                      </span>
                                    </div>
                                    <div className='mt-4'>
                                      <div className='progress' style={{height: '3px'}}>
                                        <div
                                          className='progress-bar bg-success'
                                          role='progressbar'
                                          style={{width: '25%'}}
                                        ></div>
                                      </div>
                                    </div>

                                    <div></div>

                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <span className='d-flex justify-content-center align-items-center badge rounded-pill  rounded-pill-radius bg-primary'>
                                              OF
                                            </span>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className='kanban-title-board kanban-add-card mb-6'>
                                  <div>
                                    <a className='kanban-board-add-card-hover'>
                                      <span>
                                        <i className='fa fa-plus' aria-hidden='true'>
                                          <span className='add-card'>Add a Card</span>
                                        </i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </header>
                          </main>
                        </div>
                        {/* second baord */}

                        {/* third Board */}
                        <div className='kanban-board'>
                          <main className='kanban-drag'>
                            <header className='kanban-board-header primary mb-6'>
                              <div className='kanban-title-board'>
                                <div className='d-flex justify-content-between align-items-center margin-10'>
                                  <div className='d-flex'>
                                    <a>
                                      {' '}
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        style={{marginRight: '-10px'}}
                                        viewBox='0 0 128 512'
                                      >
                                        <path d='M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z' />
                                      </svg>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        viewBox='0 0 128 512'
                                      >
                                        <path d='M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z' />
                                      </svg>
                                    </a>
                                    <h2 className='px-2'>
                                      Done <span className='fs-12px'>0</span>
                                    </h2>
                                  </div>

                                  <a>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      height='15px'
                                      width='15px'
                                      viewBox='0 0 512 512'
                                    >
                                      <path d='M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z' />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                              <div className='scroll-class'>
                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3>Create three new Landing Page Template</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-red btn-sm  text-white'>Design</span>
                                    <span className='bg-light-blue btn-sm  mx-3 text-white'>
                                      Design
                                    </span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{width: '25%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        height='15px'
                                        width='15px'
                                        style={{marginRight: '7px'}}
                                        viewBox='0 0 512 512'
                                      >
                                        <path d='M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z' />
                                      </svg>
                                      <span>20 SEP</span>
                                    </div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>Captain - 1</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip1'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip1' place='top' effect='solid'>
                                              John Smith (John Smith1)
                                            </ReactTooltip>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3> Work flow & Prototype</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-red btn-sm  text-white'>Design</span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-danger'
                                        role='progressbar'
                                        style={{width: '75%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip1'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip1' place='top' effect='solid'>
                                              John Smith (John Smith1)
                                            </ReactTooltip>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='kanban-item' data-className='light-primary'>
                                  <span className='font-weight-bold w-70'>
                                    <h3>Create three new Landing Page Template</h3>
                                  </span>
                                  <div className='d-flex mt-4'>
                                    <span className='bg-red btn-sm  text-white'>Design</span>
                                    <span className='bg-light-blue btn-sm  mx-3 text-white'>
                                      Design
                                    </span>
                                  </div>
                                  <div className='mt-4'>
                                    <div className='progress' style={{height: '3px'}}>
                                      <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{width: '25%'}}
                                      ></div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className='mt-4 d-flex align-items-center justify-content-between'>
                                      <div>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          height='15px'
                                          width='15px'
                                          style={{marginRight: '7px'}}
                                          viewBox='0 0 384 512'
                                        >
                                          <path d='M336 0h-288C21.49 0 0 21.49 0 48v431.9c0 24.7 26.79 40.08 48.12 27.64L192 423.6l143.9 83.93C357.2 519.1 384 504.6 384 479.9V48C384 21.49 362.5 0 336 0zM336 452L192 368l-144 84V54C48 50.63 50.63 48 53.1 48h276C333.4 48 336 50.63 336 54V452z' />
                                        </svg>
                                        <span className='captain-text'>v3-34</span>
                                      </div>
                                      <div className='d-flex images-card'>
                                        <ul className='d-flex'>
                                          <li>
                                            <span className='d-flex justify-content-center align-items-center badge rounded-pill  rounded-pill-radius bg-primary'>
                                              OF
                                            </span>
                                          </li>
                                          <li>
                                            <Link to='/' data-tip data-for='userTip2'>
                                              <img
                                                className='member-avatar'
                                                src='/media/avatars/blank.png'
                                                alt='John Smith (John Smith1)'
                                              />
                                            </Link>
                                            <ReactTooltip id='userTip2' place='top' effect='solid'>
                                              John Smith (John Smith2)
                                            </ReactTooltip>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className='kanban-title-board kanban-add-card mb-6'>
                                  <div>
                                    <a className='kanban-board-add-card-hover'>
                                      <span>
                                        <i className='fa fa-plus' aria-hidden='true'>
                                          <span className='add-card'>Add a Card</span>
                                        </i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </header>
                          </main>
                        </div>
                        {/* third baord */}

                        <div className='d-block h-21px'>
                          <a className='addition-svg'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='19px'
                              height='19px'
                              viewBox='0 0 512 512'
                            >
                              <path d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z' />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export {KanbanBoard}
